import { Divider, Form, message } from "antd";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CustomButton, CustomInput } from "../../../../components";
import {
  useGetUserInfo,
  useUpdateUserInfo,
} from "../../../../hooks/UserCenter/usercenter.hooks";
import styles from "./style.module.scss";

const UserInfo = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data } = useGetUserInfo({});
  const { mutate: updateUserInfo, isPending } = useUpdateUserInfo();
  const [form] = Form.useForm();

  const onSubmit = async (val: any) => {
    const submitVal = {
      ...val,
      birthday: dayjs(val.birthday).format("YYYY/MM/DD"),
    };
    delete submitVal.email;
    console.log("submitVal", submitVal);
    await updateUserInfo(
      { params: submitVal },
      {
        onSuccess: () => {
          message.success(t("normal.editSuccess"));
          navigate("/");
        },
      }
    );
  };

  useEffect(() => {
    if (data)
      form.setFieldsValue({
        ...data,
        birthday: data?.birthday
          ? dayjs(data?.birthday).format("YYYY-MM-DD")
          : null,
        gender: data.gender ?? "0",
      });
  }, [data]);

  console.log(data?.birthday);

  return (
    <div className={styles.userInfo}>
      <div className={styles.title}>{t("normal.userinfo")}</div>
      <div className={styles.formContent}>
        <Form layout="vertical" onFinish={onSubmit} form={form}>
          <div className={styles.sectionTitle}>{t("normal.account")}</div>
          <CustomInput
            formItemProps={{ name: "email", label: t("normal.email") }}
            inputProps={{ disabled: true }}
          />
          <Divider />
          <div className={styles.sectionTitle}>{t("normal.basic.info")}</div>
          <CustomInput
            formItemProps={{
              name: "name",
              label: t("normal.account.name"),
              rules: [
                {
                  required: true,
                  message: t("normal.required", {
                    name: t("normal.account.name"),
                  }),
                },
              ],
            }}
          />
          <CustomInput
            formItemType="radio"
            formItemProps={{
              name: "gender",
              label: t("normal.gender"),
              rules: [
                {
                  required: true,
                  message: t("normal.required", {
                    name: t("normal.gender"),
                  }),
                },
              ],
            }}
            radioOptions={[
              { label: t("normal.male"), value: "0" },
              { label: t("normal.female"), value: "1" },
              { label: t("normal.lgbt"), value: "2" },
            ]}
          />
          {data?.birthday ? (
            <CustomInput
              formItemProps={{
                name: "birthday",
                label: t("normal.birth"),
                initialValue: data?.birthday,
              }}
              inputProps={{
                disabled: true,
              }}
            />
          ) : (
            <CustomInput
              formItemProps={{
                name: "birthday",
                label: t("normal.birth"),
                rules: [
                  {
                    required: true,
                    message: t("normal.required", {
                      name: t("normal.birth"),
                    }),
                  },
                ],
              }}
              formItemType="datepicker"
              datepickerProps={{
                placeholder: t("normal.birthday.placeholder"),
              }}
            />
          )}
          <CustomInput
            formItemProps={{
              name: "mobile",
              label: t("normal.mobile"),
              rules: [
                {
                  required: true,
                  message: t("normal.required", {
                    name: t("normal.mobile"),
                  }),
                },
              ],
            }}
          />
          <div style={{ textAlign: "center", padding: "16px 0" }}>
            <CustomButton type="primary" htmlType="submit" loading={isPending}>
              {t("normal.save")}
            </CustomButton>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default UserInfo;
